import {useSyncExternalStore} from 'react'
import {parseDiffHash} from './document-hash-helpers'

type UseSelectedDiffHash = {
  /** The currently selected path digest (without 'diff-' prefix) */
  selectedPathDigest: string
  /** The full diff hash with prefix if available */
  selectedFullDiffHash: string
}

function subscribe(callback: () => void) {
  window.addEventListener('hashchange', callback)
  return () => window.removeEventListener('hashchange', callback)
}

function getSnapshot(): string {
  const windowHash = parseDiffHash(window.location.hash ?? '') ?? ''
  return windowHash.replace('diff-', '')
}

function getServerSnapshot(): string {
  return ''
}

/**
 * Hook that tracks the currently selected diff hash from the URL.
 *
 * This provides a consistent way to track diff navigation across different components
 * that need to respond to hash changes (like DiffFileTree, use-diff-navigation, etc.).
 *
 * @returns Object containing the selected diff hash information
 */
export function useSelectedDiffHash(): UseSelectedDiffHash {
  const selectedHash = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)

  return {
    selectedPathDigest: selectedHash,
    selectedFullDiffHash: selectedHash ? `diff-${selectedHash}` : '',
  }
}
